<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive code="ajout_actionnaire_ouinon" :live="liveSociete(25932)" v-model="sasSociete.declarerAjoutDActionnaires" ref="ajoutOuiNon" />
    <data-iterator
      :list="sas.actionnaires"
      add-new-text="Ajouter un actionnaire/associé"
      :live="{ endpoint: 'sas-ajout-actionnaire', sasId: sas.id }"
      :icon="$getIcon('job')"
      :valids="valids"
      ref="dataIterator"
      hidePoints
      :opqIf="conditionAjout"
    >
      <template v-slot:show-mode="{ item }">
        <div v-if="item.actionnaire">
          <h3>{{ item.actionnaire.fullName }}</h3>
          <p>{{ item.actionnaire.licenseNumber }}</p>
        </div>
      </template>
      <template v-slot:edit-mode="{ item }">
        <SearchActionnaire v-if="!item.actionnaire" @pharmacien-selected="pharmacienSelected(item, $event)" :idToExclude="listeToExclude">
        </SearchActionnaire>
        <div v-if="item.actionnaire">
          <h3>{{ item.actionnaire.fullName }}</h3>
          <p>{{ item.actionnaire.licenseNumber }}</p>
        </div>
        <v-checkbox
          class="list_counter_validator my-2 ml-6 p-0"
          :input-value="!!item.actionnaire"
          :rules="[() => !!item.actionnaire || 'Veuillez sélectionner un actionnaire']"
        ></v-checkbox>
      </template>
    </data-iterator>
    <DatePickerLive code="ajout_actionnaire_date" v-model="sasSociete.dateAjoutDActionnaires" :live="liveSociete(25941)" :opqIf="conditionAjout" />
    <FileInput
      code="convention_actionnaires"
      :file="sasSociete.conventionActionnaire"
      :live="liveSociete(25926)"
      :accepts="$constants.ACCEPTED_FORMATS.FILE_INPUT_WITH_PPT"
      :opq-if="conditionConvention"
    />
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import { Queue, Api } from "@/plugins/api"
import SearchActionnaire from "@/components/Formulaires/DemandeEnregistrementSociete/component/SearchActionnaire.vue"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, DatesHelpers],
  components: { SearchActionnaire },
  props: {
    sas: { type: Object }
  },

  methods: {
    pharmacienSelected(item, pharmacien) {
      Queue.enqueue(() =>
        Api.post("sas-ajout-actionnaire", {
          fileId: item.id,
          cle: "200",
          value: pharmacien.id
        }).then(() => {
          item.actionnaire = pharmacien
        })
      )
    },
    liveSociete(cle) {
      return { endpoint: "sas-societe", cle: cle, fileId: this.sasSociete.id }
    },
    liveSasAjoutActionnaire(cle, item) {
      return { endpoint: "sas-ajout-actionnaire", cle: cle, fileId: item.id }
    },
    getTextSasActionnaireDropdown(sasActionnaire) {
      const value = sasActionnaire.actionnaire.id
      let text = sasActionnaire.actionnaire.fullName + " " + sasActionnaire.actionnaire.licenseNumber || "Veuillez sélectionner un actionnaire"
      return { value, text }
    }
  },
  computed: {
    sasSociete() {
      return this.sas.sasSociete
    },
    listeToExclude() {
      return (this.sas.actionnaires?.filter((a) => a.actionnaire)?.map((a) => a.actionnaire.id) ?? []).concat(
        this.sas.retraitActionnaires?.filter((r) => r.actionnaire)?.map((r) => r.actionnaire.id) ?? []
      )
    },
    conditionConvention() {
      const nouveauxActionnaires = this.sas.actionnaires.length
      const anciensActionnaires = this.sas.retraitActionnaires.filter((a) => !a.dissociation).length
      const changementPourSpa = this.getCatalogueCodeById("328", this.sas.sasSociete.formeJuridique) === "SPA"
      const pasDeChangement = this.sas.sasSociete.formeJuridique === null
      const organisationEstSpa = this.sas.societe.codeFormeJuridique === "SPA"
      return this.conditionAjout && nouveauxActionnaires + anciensActionnaires > 1 && (changementPourSpa || (pasDeChangement && organisationEstSpa))
    },
    conditionAjout() {
      return this.estOui(this.sas.sasSociete.declarerAjoutDActionnaires)
    }
  }
}
</script>

<style></style>